/**
 * CashLab article floating table of contents + table scroll wrappers.
 * Scopes to .cl-article__content only.
 */
(function () {
  'use strict';

  function wrapArticleTables(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    Array.prototype.forEach.call(
      scope.querySelectorAll('.cl-article__content table'),
      function (table) {
        if (table.closest('.cl-article__table-scroll')) return;
        var wrap = document.createElement('div');
        wrap.className = 'cl-article__table-scroll';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      }
    );
  }

  function initCashlabToc() {
    var body = document.querySelector('.cl-article__content');
    if (!body) return false;

    var root = document.querySelector('[data-cl-toc]');
    if (!root) return false;
    if (root.getAttribute('data-cl-toc-ready') === 'true') return true;

    var listEl = root.querySelector('[data-cl-toc-list]');
    var trigger = root.querySelector('[data-cl-toc-trigger]');
    var closeBtn = root.querySelector('[data-cl-toc-close]');
    var backdrop = root.querySelector('[data-cl-toc-backdrop]');
    if (!listEl) return false;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var usedIds = Object.create(null);
    var headingNodes = [];

    function slugify(text) {
      return String(text || '')
        .toLowerCase()
        .trim()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section';
    }

    function uniqueId(base) {
      var id = base;
      var n = 2;
      while (usedIds[id] || document.getElementById(id)) {
        id = base + '-' + n;
        n += 1;
      }
      usedIds[id] = true;
      return id;
    }

    function ensureHeadingId(el) {
      if (el.id) {
        usedIds[el.id] = true;
        return el.id;
      }
      var id = uniqueId(slugify(el.textContent));
      el.id = id;
      return id;
    }

    var headings = body.querySelectorAll('h2, h3');
    if (headings.length < 3) {
      // Content is present but too short — stop watching.
      return true;
    }

    var tree = [];
    var currentH2 = null;

    headings.forEach(function (el) {
      var id = ensureHeadingId(el);
      var item = { el: el, id: id, text: el.textContent.trim(), children: [] };
      headingNodes.push(item);

      if (el.tagName === 'H2') {
        currentH2 = item;
        tree.push(item);
      } else if (currentH2) {
        currentH2.children.push(item);
      } else {
        tree.push(item);
      }
    });

    function buildLink(item) {
      var a = document.createElement('a');
      a.href = '#' + item.id;
      a.textContent = item.text;
      a.className = 'cl-article__toc-link';
      a.dataset.clTocTarget = item.id;
      return a;
    }

    listEl.innerHTML = '';
    tree.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'cl-article__toc-item';
      li.appendChild(buildLink(item));

      if (item.children.length) {
        var sub = document.createElement('ol');
        sub.className = 'cl-article__toc-sublist';
        item.children.forEach(function (child) {
          var subLi = document.createElement('li');
          subLi.className = 'cl-article__toc-item cl-article__toc-item--sub';
          subLi.appendChild(buildLink(child));
          sub.appendChild(subLi);
        });
        li.appendChild(sub);
      }

      listEl.appendChild(li);
    });

    root.hidden = false;
    root.setAttribute('data-cl-toc-ready', 'true');

    function headerOffset() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var parsed = parseFloat(raw);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 80;
    }

    function setOpen(open) {
      root.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (backdrop) backdrop.hidden = !open;
      document.documentElement.classList.toggle('cl-article-toc-open', open);
    }

    if (trigger) {
      trigger.addEventListener('click', function () {
        setOpen(!root.classList.contains('is-open'));
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setOpen(false);
      });
    }
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        setOpen(false);
      });
    }

    listEl.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-cl-toc-target]');
      if (!link) return;
      event.preventDefault();

      var id = link.getAttribute('data-cl-toc-target');
      var target = document.getElementById(id);
      if (!target) return;

      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });

      if (history.replaceState) {
        history.replaceState(null, '', '#' + id);
      } else {
        location.hash = id;
      }

      setOpen(false);
    });

    var linkById = Object.create(null);
    root.querySelectorAll('a[data-cl-toc-target]').forEach(function (a) {
      linkById[a.getAttribute('data-cl-toc-target')] = a;
    });

    var activeId = null;

    function setActive(id) {
      if (id === activeId) return;
      if (activeId && linkById[activeId]) {
        linkById[activeId].removeAttribute('aria-current');
      }
      activeId = id;
      if (activeId && linkById[activeId]) {
        linkById[activeId].setAttribute('aria-current', 'true');
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (e) {
            return e.isIntersecting;
          })
          .sort(function (a, b) {
            return a.boundingClientRect.top - b.boundingClientRect.top;
          });

        if (visible.length) {
          setActive(visible[0].target.id);
          return;
        }

        var above = headingNodes
          .filter(function (h) {
            return h.el.getBoundingClientRect().top < headerOffset() + 24;
          })
          .pop();
        if (above) setActive(above.id);
      },
      {
        root: null,
        rootMargin: '-' + (headerOffset() + 16) + 'px 0px -55% 0px',
        threshold: [0, 1]
      }
    );

    headingNodes.forEach(function (h) {
      observer.observe(h.el);
    });

    if (location.hash) {
      var hashId = location.hash.slice(1);
      if (linkById[hashId]) setActive(hashId);
    }

    return true;
  }

  function boot() {
    wrapArticleTables(document);
    if (initCashlabToc()) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var mo = new MutationObserver(function () {
      wrapArticleTables(main);
      if (initCashlabToc()) mo.disconnect();
    });
    mo.observe(main, { childList: true, subtree: true });
    window.setTimeout(function () {
      mo.disconnect();
      wrapArticleTables(document);
      initCashlabToc();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
